const _getters = {
  teamNameMaxLength: () => {
    return 50
  },
  // AHA-46165: gate self-serve team rename behind its release flag.
  canChangeTeamName: (state, getters, rootState, rootGetters) => {
    return rootGetters['featureToggles/isFeatureEnabled']('AHA-46165-release-change-team-name')
  },
}

export default _getters
